import {
  SidePanel,
  ButtonPrimary,
  ButtonSecondary,
  SidePanelType,
  Popup,
  PermissionDenied,
  PermissionEnum,
} from '@ui/src';
import { useAppSelector } from '@store';
import CreateForm from '../../../components/corporate/create/create';
import useCreate from './hooks/use-create';
import { ApplicationSchemeType } from '../../new-application/types';

import commonStyles from '../../common/common.module.css';

const CorporateCustomerCreate = (): React.JSX.Element => {
  const { applicationSchemes, deliveryChannelsCorporate } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { activePermissions, countriesList: countries } = useAppSelector(
    (state) => state.root,
  );

  const {
    control,
    errors,
    panelIsOpen,
    isDirty,
    setDirtyPopupVisible,
    handleClose,
    globalError,
    loading,
    onSubmit,
    dirtyPopupVisible,
    applicationSchemeVisible,
    setApplicationSchemeVisible,
  } = useCreate({ activePermissions });

  let content;

  if (
    !activePermissions?.includes(
      PermissionEnum.CORPORATE_CUSTOMERS_CREATE_ACTION,
    )
  ) {
    content = <PermissionDenied />;
  } else {
    content = (
      <CreateForm
        control={control}
        errors={errors}
        applicationSchemes={applicationSchemes?.filter(
          (item) => item.type === ApplicationSchemeType.CORPORATE,
        )}
        activePermissions={activePermissions}
        applicationSchemeVisible={applicationSchemeVisible}
        setApplicationSchemeVisible={setApplicationSchemeVisible}
        deliveryChannelsCorporate={deliveryChannelsCorporate}
        countries={countries}
      />
    );
  }

  return (
    <>
      <SidePanel
        type={SidePanelType.Customers}
        closeOnClickOutside
        isOpen={panelIsOpen}
        onClose={isDirty ? () => setDirtyPopupVisible(true) : handleClose}
        title="Create corporate customer"
        errorSidepanel={globalError}
        sidepanelExpandedKey="corporate-create"
        footer={
          <>
            {activePermissions?.includes(
              PermissionEnum.CORPORATE_CUSTOMERS_CREATE_ACTION,
            ) && (
              <ButtonPrimary
                text={loading ? 'Loading...' : 'Create application'}
                onClick={onSubmit}
                bold
                disabled={loading}
              />
            )}
            <ButtonSecondary text="Cancel" onClick={handleClose} bold />
            {Object.keys(errors)?.length > 0 && (
              <span className={commonStyles.createFormError}>
                There are errors in some fields
              </span>
            )}
          </>
        }
      >
        {content}
      </SidePanel>
      <Popup
        title="You have unsaved changes that will be lost"
        description="Are you sure you want to close this form?"
        onCancelClick={() => setDirtyPopupVisible(false)}
        onOkClick={handleClose}
        cancelButtonText="Cancel"
        okButtonText="Close"
        isVisible={dirtyPopupVisible}
        parent={document.getElementById('dirty-popup') as HTMLElement}
      />
      <div id="dirty-popup" />
    </>
  );
};

export default CorporateCustomerCreate;
